import * as React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Snackbar, Alert } from '@mui/material';
import FilledButton from '../components/FilledButton';
import OutlinedButton from '../components/OutlinedButton';
import { requestPasswordReset } from '../services/api';

function ForgotPassword({ open, handleClose }) {
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await requestPasswordReset(email);
      setSent(true);
    } catch (e) {
      setErrorMessage('Failed to send reset email.');
    }
  };

  return (
    <>
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit,
        sx: { backgroundImage: 'none' },
      }}
    >
      <DialogTitle>Reset password</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        {sent ? (
          <DialogContentText>
            If an account with that email exists, we’ve sent a reset link.
          </DialogContentText>
        ) : (
          <>
            <DialogContentText>
              Enter your account&apos;s email address, and we&apos;ll send you a link to
              reset your password.
            </DialogContentText>
            <div>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5 }}>
                Email Address
              </Typography>
              <TextField
                size="small"
                autoFocus
                required
                id="email"
                name="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
              />
            </div>
          </>
        )}
      </DialogContent>
      <DialogActions>
        {sent ? (
          <FilledButton onClick={handleClose} text="Close" size="small" color="primary" />
        ) : (
          <>
            <OutlinedButton onClick={handleClose} text="Cancel" size="small" color="primary" />
            <FilledButton type="submit" text="Continue" size="small" color="primary" />
          </>
        )}
      </DialogActions>
    </Dialog>
    <Snackbar
      open={!!errorMessage}
      autoHideDuration={4000}
      onClose={() => setErrorMessage('')}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={() => setErrorMessage('')} severity="error" sx={{ width: '100%' }}>
        {errorMessage}
      </Alert>
    </Snackbar>
    </>
  );
}

ForgotPassword.propTypes = {
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default ForgotPassword;
